import { Box,Card, Flex, Text, Badge, Progress, Button } from '@radix-ui/themes';
import CircleProgress from '../shared/CircleProgress';
import UserAvatar from '../common/UserAvatar';

const GuardianOverview = ({ reports }) => {
  if (!reports || reports.length === 0) return null;

  // Calculate total statistics
  const totalQuizzesAllStudents = reports.reduce((sum, report) => sum + report.quizzes.length, 0);
  const totalAttempts = reports.reduce((sum, report) => 
    sum + report.quizzes.flatMap(quiz => quiz.attempts).length, 0
  );
  
  // Get all attempts across all students
  const allAttempts = reports.flatMap(report => 
    report.quizzes.flatMap(quiz => quiz.attempts)
  );

  // Calculate overall averages including missed quizzes
  const overallAverage = totalQuizzesAllStudents > 0 
    ? reports.reduce((sum, report) => {
        const studentAttempts = report.quizzes.flatMap(quiz => quiz.attempts);
        const studentTotal = report.quizzes.length;
        const studentSum = studentAttempts.reduce((sum, attempt) => sum + attempt.percentage, 0);
        return sum + studentSum;
      }, 0) / totalQuizzesAllStudents
    : 0;

  // Calculate skill-specific averages
  const averageVocabulary = allAttempts.length > 0
    ? allAttempts.reduce((sum, attempt) => sum + attempt.vocabulary_score, 0) / allAttempts.length
    : 0;

  const averageConcept = allAttempts.length > 0
    ? allAttempts.reduce((sum, attempt) => sum + attempt.concept_score, 0) / allAttempts.length
    : 0;

  const averageApplication = allAttempts.length > 0
    ? allAttempts.reduce((sum, attempt) => sum + attempt.application_score, 0) / allAttempts.length
    : 0;

  return (
    <Card>
      <Flex direction="column" p="4" gap="4">
        {/* <Text size="5" weight="bold">Performance Overview</Text> */}
        
        {/* General Statistics */}
        <Flex direction="column" gap="1">
          <Flex direction="row" justify="between" align="center" gap="4">
              <CircleProgress label={`${Math.floor(overallAverage)}%`} labelSize="4" progress={overallAverage} size={100} />
              <Flex direction="column" gap="1" wrap="wrap" style={{flex:1}}>
                <Text weight="bold" size="2">Performance Overview</Text>
                <Flex align="center" gap="2"><Text size="1" style={{display:'block', width:70}}>Vocabulary: </Text><Progress size="3" value={averageVocabulary} color={averageVocabulary >= 70 ? 'green' : 'orange'} /></Flex>
                <Flex align="center" gap="2"><Text size="1" style={{display:'block', width:70}}>Concept: </Text><Progress size="3" value={averageConcept} color={averageConcept >= 70 ? 'green' : 'orange'} /></Flex>
                <Flex align="center" gap="2"><Text size="1" style={{display:'block', width:70}}>Application: </Text><Progress size="3" value={averageApplication} color={averageApplication >= 70 ? 'green' : 'orange'} /></Flex>
              </Flex>
          </Flex>
        </Flex>

        <Flex direction="row" justify="between">
          <Text size="2" color="gray">{reports.length} {reports.length === 1 ? 'Ward' : 'Wards'} | {totalAttempts} of {totalQuizzesAllStudents} Quizzes</Text>
          <Badge size="2">
            {Math.round((totalAttempts / totalQuizzesAllStudents) * 100) || 0}% Completion
          </Badge>
        </Flex>

        {reports.map(report => (
          <Flex justify="between" align="center" gap="2" style={{borderTop:'solid thin var(--gray-9)'}} py="2">
            <Flex align="center" gap="2">
              <UserAvatar user={report.student} size='3'/>
              <Text>{report.student.firstname} {report.student.lastname}</Text>
            </Flex>
            <Text>Avg</Text>
          </Flex>
        ))}

        {/* Performance Distribution */}
        <Flex direction="column" gap="1">
          <Text size="2" weight="bold">Performance Distribution</Text>
          <Text size="2" color="gray">
            Excellent (≥90%): {allAttempts.filter(a => a.percentage >= 90).length} quizzes
          </Text>
          <Text size="2" color="gray">
            Good (70-89%): {allAttempts.filter(a => a.percentage >= 70 && a.percentage < 90).length} quizzes
          </Text>
          <Text size="2" color="gray">
            Needs Improvement (below 70%): {allAttempts.filter(a => a.percentage < 70).length} quizzes
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};

export default GuardianOverview; 